var React = require('react');

function VideoInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0","y":"0","width":"14","height":"9.009","style":{"fill":"none"},"key":0}),React.createElement("g",{"key":1},React.createElement("path",{"d":"M13.817,0.852c-0.121,-0.061 -0.243,-0.061 -0.304,0l-2.13,1.644l0,-0.731c0,-0.974 -0.792,-1.765 -1.766,-1.765l-7.852,0c-0.974,0 -1.765,0.791 -1.765,1.765l0,5.478c0,0.974 0.791,1.766 1.765,1.766l7.852,0c0.974,0 1.766,-0.792 1.766,-1.766l0,-0.73l2.13,1.644c0.061,0.06 0.183,0.06 0.304,0c0.122,-0.061 0.183,-0.122 0.183,-0.244l0,-6.817c0,-0.122 -0.061,-0.183 -0.183,-0.244Z","style":{"fillRule":"nonzero"}}))]);
}

VideoInline.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 14 10","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = VideoInline;

VideoInline.default = VideoInline;
